import {
  ORDER_TAB_DONE,
  ORDER_TAB_PROCESSING,
  ORDER_TAB_WAIT_PAYMENT,
} from '@teko/order';

export { ORDER_TAB_WAIT_PAYMENT } from '@teko/ecommerce';
export { CONSUMER_ORDER_STATUSES } from '@teko/order';

export const ORDER_TABS = [
  {
    id: ORDER_TAB_WAIT_PAYMENT,
    title: 'Chờ thanh toán',
  },
  {
    id: ORDER_TAB_PROCESSING,
    title: 'Chờ giao hàng',
  },
  {
    id: ORDER_TAB_DONE,
    title: 'Đã hoàn thành',
  },
];

export const MAPPING_TAB_ORDER: { [key: string]: number } = {
  WAIT_PAYMENT: 0,
  PROCESSING: 1,
  DONE: 2,
};

export const MAPPING_TAB_ORDER_REVERT: { [key: number]: string } = {
  0: 'WAIT_PAYMENT',
  1: 'PROCESSING',
  2: 'DONE',
};

export const ORDER_SESSION_STORAGE_KEY = 'theLastOrder';
export const ORDER_SELLER_SKUS_MAPPING_KEY = 'sellerSkusMapping';
